import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { FacilityItem, IFacility, Label } from 'components-modules/facilities-status.js';
import { IModule } from 'redux-state/layout/types.js';
import { setDefaultTitle } from 'utilities/text/titleDefault.js';

interface IFacilities {
  highAltitude: string;
  verticalDrop: string;
  baseAltitude: string;
  facilityList: IFacility[];
}

const Facilities = (props: IModule<IFacilities>) => {
  const {
    config: { highAltitude, verticalDrop, baseAltitude, facilityList },
  } = props;

  return (
    <Tile dataModule="facilities" {...props}>
      <div className="Tile-body">
        <TileBodyHeaderV2
          isDrawer={props.isDrawer}
          modulePath={props.modulePath}
          config={setDefaultTitle(props.config, 'Lifts and Facilities')}
        />

        <div className="Grid">
          <div className="Grid-cell u-width1of1 u-md-width1of3">
            <Label label="Highest altitude" value={highAltitude} />
          </div>
          <div className="Grid-cell u-width1of1 u-md-width1of3">
            <Label label="Vertical drop" value={verticalDrop} />
          </div>
          <div className="Grid-cell u-width1of1 u-md-width1of3">
            <Label label="Base altitude" value={baseAltitude} />
          </div>
        </div>

        {facilityList.map((facility, index) => {
          if (facility.items.length === 0) {
            return null;
          }

          return (
            <div key={index} className="Grid">
              <h3 className="Grid-cell u-width1of1 u-mT-sm u-mB-xs">{facility.facilityTypeName}</h3>

              {facility.items.map((item, idx) => (
                <div key={idx} className="Grid-cell u-width1of1 u-md-width1of3">
                  <FacilityItem item={item} idx={idx} />
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </Tile>
  );
};

export { Facilities };
